export default "__VITE_ASSET__DE$uME5D__"